<template>
  <div class="alert-info-item" @click="onAppSelected">
    <div class="home-revm-alert-info-item">
      <div class="icon-container">
        <BaseIcon
          :name="iconMap[capability]"
          width="2rem"
          height="2rem"
          :style="{ fill: 'rgb(245, 150, 0)' }"
        />
      </div>
      <div class="label-container">
        <div class="app-name">
          {{ itemKey }}
        </div>
        <div class="app-cap">
          {{ labelMap[capability] }}
        </div>
      </div>
    </div>
    <div class="app-value">
      <div>{{ itemValue || 0 }}</div>
    </div>
  </div>
</template>
<script>
import i18n from '@/plugins/i18n';
const iconMap = {
  B: 'browser',
  A: 'apm',
  M: 'mobile',
  D: 'database',
  V: 'vm',
  W: 'wsm',
  S: 'sm',
  K: 'k8m',
  Q: 'mq',
  L: 'log',
  ANL: 'analytics',
  C: 'cloud',
};

const labelMap = {
  B: i18n.global.t('browserMonitoring'),
  A: i18n.global.t('usage.APM'),
  M: i18n.global.t('mobileMonitoring'),
  D: i18n.global.t('databaseMonitoring'),
  V: i18n.global.t('vmMonitoring'),
  W: i18n.global.t('web-server-monitoring'),
  S: i18n.global.t('syntheticMonitoring'),
  K: i18n.global.t('k8m'),
  Q: i18n.global.t('mq.mqMonitoring'),
  L: i18n.global.t('logMonitoring'),
  ANL: i18n.global.t('analyticsCap'),
  C: i18n.global.t('cloudSvc'),
};

export default {
  data() {
    return {
      type: 'ByCap',
      iconMap,
      labelMap,
    };
  },
  props: {
    itemKey: { type: String, default: '' },
    itemValue: { type: [String, Number], default: '' },
    color: { type: String, required: '' },
    capability: { type: String, required: true },
    animationDelay: { type: String, default: '2s' },
    serviceName: { type: String, default: '' },
    serviceId: { type: String, default: '' },
  },
  methods: {
    onAppSelected() {
      this.$router.push({
        name: 'alertsV2',
        query: {
          id: this.serviceId,
        },
      });
    },
  },
};
</script>
<style scoped>
.alert-info-item {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: #191919;
  animation: fadeIn 2s;
  cursor: pointer;
  border-radius: 0.5rem;
}
.app-value {
  display: flex;
  font-size: 1.4rem;
  font-weight: bold;
  padding: 0.5rem;
}
.key {
  font-size: 1rem;
}
.icon-container {
  display: flex;
  padding: 0.5rem;
  background-color: black;
  border-radius: 0.5rem;
}
.label-container {
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
}
.app-name,
.app-cap {
  text-align: left;
}
.app-cap {
  color: #9a9898;
  font-size: 0.875rem;
}

@keyframes fadeIn {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.alert-info-item:hover {
  /* transform: scale(1.05);
  transition: all .2s ease-in-out; */
}

.home-revm-alert-info-item {
  display: flex;
}
</style>
